import { useAuth } from '../../../hooks/useAuth';
import DREFranquia from './DREFranquia';
import DREClub from './DREClub';

const DRE = () => {

  const { ...auth } = useAuth()
  const isClubUser = (auth.isM3tasUser() || auth.isGlobalUser())

  return (
    <>
      {isClubUser ? (
        <DREClub />
      ) : (
        <DREFranquia />
      )}
    </>
  )
}

export default DRE